import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { PathwayUser, PlanAssignment } from '@/_generated/api-clients/xp';

const DEFAULT_STATE = {
  activePlanId: '' as string | undefined,
  isTrainingModeOpen: false,
  hasTeamMembersAssignedToPlan: false,
  showProgressModal: false,
  showTrainTogetherPopup: false,
  isTrainingMode: false,
  isBeforeNavigate: false,
  allAssigneesCompleted: false,
  // @TODO: Are we sure this shape is in step with API.  Should we be derriving this from fetch API, or using primitives to inform subsequent update requests.
  trainingModeData: {
    estimatedMinutes: 0 as number,
    languageSelected: '',
    planId: '' as string,
    planLabel: '',
    planName: '',
    teamMembers: [],
    selectedTeamMembers: [] as PathwayUser[],
    assignedTeamMembersStatus: [] as PlanAssignment[] | undefined,
  },
};

export const trainingModeBaseAtom = atomWithStorage(
  'app.training.mode',
  DEFAULT_STATE,
);

const base = trainingModeBaseAtom;

export const trainingModeAtom = atom(
  get => get(base),
  (get, set, patch: Partial<typeof DEFAULT_STATE>) => {
    set(base, { ...get(base), ...patch });
  },
);

type Action =
  | 'enterTrainingMode'
  | 'exitTrainingMode'
  | 'hideProgressModal'
  | 'showTrainingMode'
  | 'hideTrainingMode'
  | 'showProgressModal'
  | 'resetTrainingModeData';

export const trainingModeDispatchAtom = atom(
  get => get(base),
  (get, set, action: Action) => {
    switch (action) {
      case 'showTrainingMode':
        return set(base, { ...get(base), isTrainingModeOpen: true });
      case 'hideTrainingMode':
        return set(base, { ...get(base), isTrainingModeOpen: false });
      case 'showProgressModal':
        return set(base, { ...get(base), showProgressModal: true });
      case 'hideProgressModal':
        return set(base, { ...get(base), showProgressModal: false });
      case 'enterTrainingMode':
        return set(base, { ...get(base), isTrainingMode: true });
      case 'exitTrainingMode':
        return set(base, { ...get(base), isTrainingMode: false });
      case 'resetTrainingModeData':
        return set(base, {
          ...get(base),
          trainingModeData: {
            estimatedMinutes: 0,
            languageSelected: '',
            planId: '',
            planLabel: '',
            planName: '',
            teamMembers: [],
            selectedTeamMembers: [],
            assignedTeamMembersStatus: [],
          },
        });
    }
  },
);
